<template>
<div class ="our-people">
    <b-container>
        <!-- <b-row>
            <b-col md="12" sm="12" class="head">
                <headings :data="heading" />
            </b-col>
        </b-row> -->
		<b-row v-for="(person,index) in persons" :key="index">
		<b-col class="person-data">
	
			<Peopleinfo :person="person" />
		
		</b-col>
		</b-row>
    </b-container>
</div>
</template>
<script>
import Peopleinfo from './people-info'
export default {
  name: 'Ourpeople',
  props: ['heading','owners','persons'],
  components: {
   Peopleinfo
  },
  data () {
    return {
		
	}
  }
}
</script>
<style scoped>
.card1 {
			border-radius: 20px;
			box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.4);
			width: 85%;
			height: 85%;
		}
		.founder-title {
			font-size: 20px;
			font-weight: 700;
			color: #2A4B7C;
		}
		.founder-designation {
			font-size: 17px;
			font-weight: 600;
			color: #2A4B7C;
		}
		.description-text {
			font-size: 15px;
			color:#2A4B7C;
			padding-left: 0.75rem;
			padding-right: 0.75rem;
		}

.head{
	padding-left:0;
}
@media (min-width: 481px) and (max-width: 767px) {
.person-data{
		margin-top:2rem;
	}

}
@media (max-width: 480px) {
	.person-data{
		margin-top:2rem;
	}
}
</style>